<template>
    <div
        class="t-shops-row overflow-visible gap-1"
        :class="{ 't-shops-row--active': shopChecked }"
    >
        <div class="t-shops-info">
            <ui-checkbox-input
                v-model="shopChecked"
                class="text-primary text-sm"
                :name="`shop-${promotion.id}-${shop.id}-${priceGroupIdx}`"
                :label="setShopLabel"
                :disabled="isCheckedInAnotherPriceGroup || isNextPriceGroup"
            />
        </div>

        <a-icon
            v-if="isLocalCodeError || isMandatoryPriceError"
            v-tooltip="isLocalCodeError || isMandatoryPriceError"
            class="text-danger"
            icon="InvalidMark"
        />

        <span
            v-if="showChangePricesButton || (shopChecked && isShopActive)"
            class="t-shopMoreButton text-primary d-none d-md-flex cursor-pointer"
            :class="{ 'is-open': isShopActive }"
            @click="showShopPrices"
        >
            <strong v-if="shopChecked && isShopActive">
                Zwiń
            </strong>

            <strong v-if="showChangePricesButton">
                {{ changePricesButtonText }}
            </strong>
        </span>

        <the-btn
            v-if="(shopChecked && isShopActive) || showChangePricesButton"
            class="btn-outline-secondary d-flex d-md-none"
            icon="Filter"
            @click.native="showShopPrices"
        >
        </the-btn>

        <div
            v-if="shopChecked && isShopActive && !isNoItemsPromo"
            class="sth m-changePrices"
        >
            <div
                v-if="previewType !== 'labels'"
                class="m-changePrices__header"
                :class="[{ '--isMargin': isMargin }]"
            >
                <span>{{ hasSets ? 'Zestawy' : 'Produkty' }} promocyjne</span>

                <span v-if="isMargin" class="d-none d-sm-block">
                    Marża %
                    <a-icon
                        v-tooltip="$store.getters.getWholesalePriceMarginTooltip('all')"
                        style="width: 14px; height: 14px"
                        icon="Info"
                    />
                </span>

                <template v-if="previewType !== 'labels'">
                    <span
                        v-if="
                            !promotion.all_eans_present &&
                                !promotion.equalLocalCodes &&
                                !hasSets
                        "
                    >Kod lokalny</span>

                    <template
                        v-if="!promotion.subscriptionsEqualPrices.equalPrices"
                    >
                        <span v-if="showItemInput">Cena <span class="nowrap">za sztukę</span></span>
                        <span v-if="promotion.type === 'Promo::Quota'">Rabat brutto</span>
                        <span
                            v-else-if="promotion.type === 'Promo::BondedQuota'"
                        >
                            Rabat brutto
                            <span class="nowrap">do zestawu</span>
                        </span>
                        <span
                            v-else-if="
                                promotion.type === 'Promo::BondedPercentage'
                            "
                        >
                            Rabat %
                            <span class="nowrap">do zestawu</span>
                        </span>
                        <span
                            v-else-if="$store.getters.isWeight(promotion.type)"
                        >
                            Cena w promocji
                            <span class="nowrap">za KG</span>
                        </span>
                        <span v-else>
                            <span>{{ hasSets ? 'Twoja cena zestawu' : 'Cena' }}</span>
                            w promocji
                        </span>
                    </template>
                </template>
            </div>
            <div class="t-shops-products mb-0 pb-0 border-bottom-0">
                <template v-if="!hasSets || previewType === 'labels'">
                    <!-- LABELS -->
                    <template v-if="previewType === 'labels'">
                        <div class="custom-checkbox mb-3 mt-2">
                            <the-btn
                                text="Zaznacz wszystkie główne"
                                class="btn-outline-custom d-none d-sm-inline-flex"
                                icon="CheckCorrect"
                                @click.native="selectAllProducts(true)"
                            />

                            <the-btn
                                text="Odznacz wszystkie"
                                class="btn-danger ml-sm-2 d-none d-sm-inline-flex"
                                icon="CheckIncorrect"
                                @click.native="selectAllProducts(false)"
                            />
                        </div>

                        <div class="m-changePrices__header pt-0 border-top-0">
                            <span>Produkt</span>

                            <span v-if="showPriceLowest" class="d-flex">
                                <span>Cena z 30 dni</span>
                                <a-icon
                                    icon="Info"
                                    width="16"
                                    height="16"
                                    v-tooltip="{
                                        content: $store.getters.isWeight(
                                            promotion.type
                                        )
                                            ? 'Najniższa cena przed obniżką'
                                            : 'Najniższa cena towaru z 30 dni przed obniżką'
                                    }"
                                />
                            </span>

                            <span v-if="showRegularPriceInput">Cena poza promocją</span>
                            <span v-if="showPriceLowestDiscount">Cena za kg sprzed obniżki</span>

                            <span>Liczba kopii</span>

                            <span v-if="showExtraFieldCol" style="width: 58px; max-width: 58px" />
                        </div>

                        <product-tree
                            class="m-labels__products m-labels__productsShop"
                            product-class="m-labels__product"
                            preview-type="labels"
                            component-name="LabelProduct"
                            fetching-method-name="loadLabelsProductsAndResources"
                            :products="promotionalProducts"
                            :promotion="promotion"
                            :merchant-id="sub"
                            :show-regular-price-input="showRegularPriceInput"
                            :selected-labels="true"
                            :show-price-lowest="showPriceLowest"
                            :show-price-lowest-discount="showPriceLowestDiscount"
                            @subproducts-fetched="updateProducts"
                            @has-extra-fields="showExtraFields = $event"
                        />
                    </template>

                    <!-- NOT LABELS -->
                    <template v-else>
                        <product-tree
                            :promotion="promotion"
                            :products="promotionalProducts"
                            :merchant-id="sub"
                            fetching-method-name="fetchProductsByPromoGroupPromo"
                            component-name="ChangePriceProduct"
                            :preview-type="previewType"
                        />
                    </template>

                    <page-preloader
                        v-if="promotion.productsStatus === 'loading'"
                        min-height="123px"
                    />

                    <the-btn
                        v-if="
                            promotion.productsPagination &&
                                promotion.productsPagination.nextPage
                        "
                        class="mt-3"
                        @click.native="showMoreProducts"
                    >Pokaż więcej produktów
                    </the-btn>
                </template>

                <template v-else-if="hasSets">
                    <change-price-product-sets
                        v-for="(productSet, idxx) in productSets"
                        @priceChange="val => (productSet.priceChange = val)"
                        :product-set="productSet"
                        :key="idxx"
                        :set-idx="idxx"
                        :promotion="promotion"
                        :merchant-id="sub"
                        :group-id="groupId"
                    />
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import ChangePriceProductSets from '@/components/promotions/ChangePriceProductSets'
import { wtMerchants } from '@/walkthroughs/wtData'
import promoBonded from '@/mixins/promoBonded'

export default {
    mixins: [promoBonded],
    props: {
        sub: {
            type: Number,
            required: true
        },
        promotion: {
            type: Object,
            required: true
        },
        selectedShops: {
            type: Array,
            required: true
        },
        subscriptions: {
            type: Array,
            default: () => []
        },
        activeShop: {
            type: Number,
            required: true
        },
        groupId: {
            type: Number,
            required: true
        },
        priceGroupIdx: {
            type: Number,
            required: true
        },
        previewType: {
            type: String,
            default: ''
        },
        showPriceLowest: {
            type: Boolean,
            default: false
        },
        showPriceLowestDiscount: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        showExtraFieldCol: false
    }),
    components: {
        ChangePriceProductSets
    },
    computed: {
        subscription() {
            return this.subscriptions.find(sub => sub.merchant_id === this.sub)
        },

        subscriptionId() {
            return this.subscriptions.find(sub => sub.merchant_id === this.sub).id
        },

        promotionalProducts() {
            if (this.previewType !== 'labels') {
                return this.promotion.products
            }

            // For labels, we need to merge products with product_subscriptions
            if (!this.subscription) {
                return []
            }

            // Merge products and product_subscriptions
            return this.subscription.products.map(product => {
                const productSubscription = (this.subscription.product_subscriptions || []).find(
                    ps => ps.promo_dict_product_id === product.id
                )
                return {
                    ...productSubscription,
                    ...product,
                    id: product.id // Ensure ID is coming from product
                }
            })
        },

        shop() {
            if (this.$store.getters.getWalkthroughActive) {
                return wtMerchants.find(el => el.id === this.sub)
            } else {
                return this.$store.getters.getMerchantById(this.sub)
            }
        },

        shopChecked: {
            get() {
                return this.selectedShops.find(
                    el => el.merchant_id === this.sub
                ).checked
            },
            set(value) {
                this.$store.dispatch('selectShop', {
                    value,
                    promoId: this.promotion.id,
                    groupId: this.promotion.groupId,
                    shopId: this.sub,
                    promotion: this.promotion,
                    previewType: this.previewType,
                    equalPrices:
                        this.promotion.subscriptionsEqualPrices.equalPrices ||
                        this.promotion.equalLocalCodes,
                    groupIdx: this.priceGroupIdx,
                    fromPromoDetails: this.$store.getters.modalState?.args
                        ?.singleSubscription
                })
            }
        },

        merchants() {
            return this.$store.getters.getMerchants
        },

        activeShopLocal: {
            get() {
                return this.activeShop
            },
            set(value) {
                this.$emit('onChangeActiveShop', value)
            }
        },

        setShopLabel() {
            const data = this.shop
            return `${data.name}, ${this.$store.getters.getShopAddress(data)}`
        },

        hasSets() {
            return this.$store.getters.hasProductSets(this.promotion.type)
        },

        isMargin() {
            const { promotion, previewType } = this

            if (previewType === 'labels') {
                return false
            }

            if (!this.$store.getters.isMarginType(promotion.type)) {
                return false
            }

            return true
        },

        showRegularPriceInput() {
            let show = false
            if (
                this.promotion.type !== 'Promo::RegularPrice' &&
                this.promotion.type !== 'Promo::WeightRegularPrice' &&
                this.promotion.type !== 'Promo::WeightPeriodicPriceReduction'
            ) {
                show = true
                if (
                    this.promotion.type === 'Promo::PeriodicPriceReduction' &&
                    !this.promotion.loyalty
                ) {
                    show = false
                }
            }
            return show
        },

        showChangePricesButton() {
            const commonConditions =
                this.shopChecked && !this.isNoItemsPromo && !this.isShopActive

            if (!this.promotion.all_eans_present) {
                return (
                    commonConditions &&
                    (!this.promotion.subscriptionsEqualPrices?.equalPrices ||
                        (!this.promotion.equalLocalCodes && !this.hasSets))
                )
            } else {
                return (
                    commonConditions &&
                    !this.promotion.subscriptionsEqualPrices?.equalPrices
                )
            }
        },

        isCheckedInAnotherPriceGroup() {
            let checkboxDisabled = false
            if (
                this.promotion.subscriptionsEqualPrices.equalPrices ||
                this.promotion.equalLocalCodes
            ) {
                this.promotion.subscriptionsEqualPrices.priceGroups.forEach(
                    (el, idx) => {
                        if (
                            el.find(child => child.merchant_id === this.sub) &&
                            el.find(child => child.merchant_id === this.sub)
                                .checked &&
                            idx !== this.priceGroupIdx
                        ) {
                            checkboxDisabled = true
                        }
                    }
                )
            }
            return checkboxDisabled
        },

        isNextPriceGroup() {
            let checkboxDisabled = false
            if (
                this.promotion.subscriptionsEqualPrices.equalPrices ||
                this.promotion.equalLocalCodes
            ) {
                const thisPriceGroup = this.promotion.subscriptionsEqualPrices
                    .priceGroups[this.priceGroupIdx]
                const checkedSubs = thisPriceGroup?.filter(el => el.checked)
                const nextPriceGroup = this.promotion.subscriptionsEqualPrices
                    .priceGroups[this.priceGroupIdx + 1]
                if (
                    nextPriceGroup &&
                    checkedSubs.length === 1 &&
                    this.shopChecked
                ) {
                    checkboxDisabled = true
                }
            }
            return checkboxDisabled
        },

        changePricesButtonText() {
            const { promotion } = this

            if (
                promotion.type.includes('RegularPrice') &&
                this.previewType === 'labels'
            ) {
                return 'Liczba kopii'
            }
            if (this.promotion.all_eans_present) {
                return 'Zmień ceny'
            }
            if (
                !promotion.subscriptionsEqualPrices.equalPrices &&
                !promotion.equalLocalCodes &&
                !this.hasSets
            ) {
                return 'Zmień ceny i kody'
            }
            if (
                promotion.subscriptionsEqualPrices.equalPrices &&
                !promotion.equalLocalCodes
            ) {
                return 'Zmień kody'
            }
            return 'Zmień ceny'
        },

        isLocalCodeError() {
            if (!this.$store.getters.getLocalCodesValidation) return
            let errorText = ''
            const error = this.$store.getters.getLocalCodeError({
                subscriptionId: this.subscriptionId
            })
            if (error) {
                if (error.type === 'emptyEan') {
                    errorText = 'W tym sklepie nie ma żadnego kodu lokalnego'
                } else {
                    errorText = error.error
                }
            }
            return errorText
        },
        isMandatoryPriceError() {
            if (!this.$store.getters.getMandatoryPriceValidation) return
            let errorText = ''
            let noPriceLowestError
            let noPriceNormalError
            let noWeightPriceNormalError
            if (this.showPriceLowest) {
                noPriceLowestError = this.$store.getters.getMandatoryPriceError(
                    {
                        subscriptionId: this.subscriptionId,
                        promoId: this.promotion.id,
                        groupId: this.groupId,
                        type: 'noPriceLowest'
                    }
                )
            }
            if (this.showRegularPriceInput) {
                noPriceNormalError = this.$store.getters.getMandatoryPriceError(
                    {
                        subscriptionId: this.subscriptionId,
                        promoId: this.promotion.id,
                        groupId: this.groupId,
                        type: 'noPriceNormal'
                    }
                )
            }
            if (this.showPriceLowestDiscount) {
                noWeightPriceNormalError = this.$store.getters.getMandatoryPriceError(
                    {
                        subscriptionId: this.subscriptionId,
                        promoId: this.promotion.id,
                        groupId: this.groupId,
                        type: 'noWeightPriceNormal'
                    }
                )
            }
            const error =
                noPriceLowestError ||
                noPriceNormalError ||
                noWeightPriceNormalError
            if (error) {
                if (
                    error.type === 'noPriceLowest' ||
                    error.type === 'noPriceNormal' ||
                    error.type === 'noWeightPriceNormal'
                ) {
                    errorText =
                        'W tym sklepie nie jest uzupełniona cena omnibus oraz/lub cena poza promocją'
                } else {
                    errorText = error.error
                }
            }
            return errorText
        },
        productSets() {
            const sets = this.promotion.product_sets

            if (this.isBonded) {
                return sets.filter(
                    set => set.type === 'ProductSet::Promotional'
                )
            } else {
                return sets
            }
        },

        isShopActive() {
            return this.activeShopLocal === this.shop.id
        },

        isNoItemsPromo() {
            return this.$store.getters.isNoItemsPromo(this.promotion.type)
        }
    },
    methods: {
        selectAllProducts(selected) {
            this.$store.dispatch('selectAllLabelProducts', {
                selected,
                groupId: this.groupId,
                promoId: this.promotion.id,
                merchantId: this.sub
            })
        },

        async showMoreProducts() {
            const { product_sets } = this.promotion

            const payload = {
                main: true,
                groupId: this.groupId,
                promoId: this.promotion.id,
                productSetId:
                    product_sets && product_sets[0] && product_sets[0].id
            }

            if (this.previewType === 'labels') {
                const paging = this.promotion.productsPagination
                const per = paging.perPage === 10 ? 100 : paging.perPage
                const page = paging.perPage === 10 ? 1 : paging.nextPage

                await this.$store.dispatch('loadLabelsProductsAndResources', {
                    ...payload,
                    per,
                    page,
                    selectedLabels: true,
                    promo: this.promotion
                })
            } else if (this.previewType === 'group-accept') {
                const res = await this.$store.dispatch(
                    'fetchProductsByPromoGroupPromo',
                    {
                        ...payload,
                        fromSelectedGroups: true
                    }
                )

                if (this.promotion.all_eans_present) {
                    return
                }

                this.$store.dispatch('setMerchantEansInSelectedPromoGroup', {
                    products: res,
                    promotion: this.promotion,
                    params: {
                        per: 99999
                    }
                })
            } else {
                this.$store.dispatch('fetchProductsByPromoGroupPromo', payload)
            }
        },

        showShopPrices() {
            if (!this.isShopActive) {
                this.activeShopLocal = this.shop.id
            } else {
                this.activeShopLocal = 0
            }
        },
        updateProducts({ productId, subProducts }) {
            if (this.previewType !== 'labels') {
                return
            }
            const selectedGroups = this.$store.getters.getSelectedLabelGroupsJson
            const group = selectedGroups.find(({ id }) => id === this.groupId)
            const promo = group.promos.find(({ id }) => id === this.promotion.id)
            const sub = promo.subscriptions.find(({ merchant_id }) => merchant_id === this.sub)
            const product = sub.products.find(({ id }) => id === productId)
            product.subProducts = subProducts.map(subProduct => ({
                ...subProduct,
                downloadLabel: false
            }))

            this.$store.commit('SET_SELECTED_LABELGROUPS', selectedGroups)
        }
    },
    watch: {
        'promotion.subscriptionsEqualPrices.equalPrices'() {
            if (!this.showChangePricesButton) {
                this.activeShopLocal = 0
            }
        },
        'promotion.equalLocalCodes'() {
            if (!this.showChangePricesButton) {
                this.activeShopLocal = 0
            }
        }
    }
}
</script>
